

import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_CUSTOMERS_WITH_AUTOCHARGE_DISABLED = createActionTypes('FETCH_CUSTOMERS_WITH_AUTOCHARGE_DISABLED');

